export interface UpsertUserTeamLead {
    teamLeadPayinCommissionRate: string;
    teamLeadPayoutCommissionRate: string;
}
